'use client'

import { motion } from 'framer-motion'
import { Loader2 } from 'lucide-react'
import { LoadingState } from '../../ui/LoadingState'

export function StepEnviando() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="flex flex-col items-center gap-6 py-8">
      <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className="w-20 h-20 rounded-full bg-purple-500/20 flex items-center justify-center">
        <motion.div animate={{ rotate: 360 }} transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}><Loader2 size={40} className="text-purple-500" /></motion.div>
      </motion.div>
      <div className="text-center space-y-2">
        <LoadingState text="Enviando sua solicitacao" size="lg" />
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5 }} className="text-indigo-950/40 dark:text-white/40 text-sm">Isso leva apenas alguns segundos</motion.p>
      </div>
    </motion.div>
  )
}
